<template>
  <div class="container">
    <div class="content-bg">
      <div class="inline-wrapper ranking-date">
        <div class="date-left-r">
          <div style="display: flex;align-items: center;">
            <div class="header-tab">
              <span
                @click="handCommand('daterange')"
                :class="{'fisrt-box':true, active: timeType == 'daterange'}"
              >Daily</span>
              <span
                @click="handCommand('weekrange')"
                :class="{'three-box':true, active: timeType == 'weekrange'}"
              >Weekly</span>
              <span
                @click="handCommand('monthrange')"
                disabled="true"
                :class="{'two-box':true,active: timeType == 'monthrange'}"
              >Monthly</span>
            </div>
            <el-date-picker
              v-model="chooseDate"
              v-show="timeType == 'daterange'"
              type="daterange"
              start-placeholder="Start Time"
              end-placeholder="End Time"
              size="small"
              clearable
              value-format="timestamp"
              :default-time="['00:00:00', '23:59:59']"
              @change="dataPickChange"
              :picker-options="pickerOptions"
            ></el-date-picker>
            <el-date-picker
              v-show="timeType == 'weekrange'"
              v-model="weekStartValue"
              type="week"
              size="small"
              format="yyyy wWW"
              :picker-options="{firstDayOfWeek: 1}"
              placeholder="Start Time"
              @change="changeStartTime"
            ></el-date-picker>
            <span v-show="timeType == 'weekrange'" style="margin: 0 10px;">to</span>
            <el-date-picker
              v-show="timeType == 'weekrange'"
              v-model="weekEndValue"
              type="week"
              size="small"
              format="yyyy wWW"
              :picker-options="{firstDayOfWeek: 1}"
              placeholder="End Time"
              @change="changeEndTime"
            ></el-date-picker>
            <el-date-picker
              v-model="monthDate"
              v-show="timeType == 'monthrange'"
              type="monthrange"
              start-placeholder="Start Time"
              end-placeholder="End Time"
              size="small"
              clearable
              value-format="timestamp"
              :default-time="['00:00:00', '23:59:59']"
              @change="dataPickChange"
            ></el-date-picker>
            <el-form
              inline
              size="mini"
              class="table-search-part more-search-part inline-wrapper"
              @submit.native.prevent="handleQuery()"
            >
              <!-- <el-form-item label="Channel Type" style="margin-right: 10px;">
                  <el-select v-model="ChannelType" filterable @change="agentChange">
                    <el-option
                      v-for="item in agentList"
                      :key="item.id"
                      :label="item.name"
                      :value="item.id"
                    ></el-option>
                  </el-select>
              </el-form-item>-->
              <el-form-item label="Merchant Level 1" style="margin-left: 10px;">
                <el-select
                  v-model="partner"
                  filterable
                  placeholder="select"
                  @change="partnerChange"
                  clearable
                >
                  <el-option
                    v-for="item in partnerSelect"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id"
                  ></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="Merchant Level 2" style="margin-left: 10px;">
                <el-select
                  v-model="masterDistributor"
                  filterable
                  placeholder="select"
                  @change="masterDistributorChange"
                  clearable
                >
                  <el-option
                    v-for="item in masterDistributorSelect"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id"
                  ></el-option>
                </el-select>
              </el-form-item>
              <!-- <el-form-item label="Merchant Level 3" style="margin-right: 10px;">
                  <el-select
                    @change="distributorChange"
                    v-model="distributor"
                    filterable
                    placeholder="select"
                    clearable
                  >
                    <el-option
                      v-for="item  in distributorSelect"
                      :key="item.id"
                      :label="item.name"
                      :value="item.id"
                    ></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="Merchant Level 4" style="margin-right: 10px;">
                  <el-select
                    v-model="company"
                    @change="companyChange"
                    filterable
                    placeholder="select"
                    clearable
                  >
                    <el-option
                      v-for="item in companySelect"
                      :key="item.id"
                      :label="item.name"
                      :value="item.id"
                    ></el-option>
                  </el-select>
              </el-form-item>-->
              <el-form-item label="Channel" style="margin-left: 10px;">
                <el-select
                  v-model="queryData.channelId"
                  placeholder="Merchant"
                  clearable
                  filterable
                  :popper-append-to-body="false"
                  @change="merchantIdChange"
                >
                  <el-option
                    v-for="item in merchatList"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id"
                  ></el-option>
                </el-select>
              </el-form-item>
              <!-- <el-form-item label="Label" style="margin-left: 10px;">
                <el-select
                  v-model="queryData.labelIds"
                  multiple
                  filterable
                  collapse-tags
                  placeholder="Label"
                  :popper-append-to-body="false"
                >
                  <el-option
                    v-for="item in lableList"
                    :key="item.id"
                    :label="item.labelName"
                    :value="item.id"
                  ></el-option>
                </el-select>
              </el-form-item>-->
            </el-form>
          </div>
          <div class="ranking-search">
            <el-form
              inline
              size="mini"
              class="table-search-part more-search-part inline-wrapper"
              @submit.native.prevent="handleQuery()"
            >
              <div>
                <el-form-item label="User Limit" style="margin-left: 10px;">
                  <el-select
                    v-model="queryData.levelId"
                    filterable
                    clearable
                    placeholder="User Limit"
                  >
                    <el-option
                      v-for="item in sortedArr"
                      :key="item.id"
                      :label="item.name"
                      :value="item.id"
                    ></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="Level">
                  <el-select
                    v-model="queryData.userLevelIds"
                    multiple
                    filterable
                    collapse-tags
                    placeholder="Level"
                    :popper-append-to-body="false"
                  >
                    <el-option
                      v-for="item in levelList"
                      :key="item.id"
                      :label="item.name"
                      :value="item.id"
                    ></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="Bet Type" style="margin-right: 10px;">
                  <el-select v-model="queryData.seriesType" filterable>
                    <el-option
                      v-for="item in betList"
                      :key="item.id"
                      :label="item.name"
                      :value="item.id"
                    ></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="Level Update Time" label-width="110px">
                  <el-date-picker
                    v-model="userLevelUpdateTime"
                    type="datetimerange"
                    format="yyyy-MM-dd HH:mm"
                    :default-time="['00:00:00', '23:59:59']"
                    value-format="timestamp"
                    range-separator="-"
                    start-placeholder="Start time"
                    end-placeholder="End time"
                    clearable
                  />
                </el-form-item>
                <el-form-item label="Label" class="label-box">
                  <el-select
                    v-model="queryData.labelIds"
                    multiple
                    filterable
                    collapse-tags
                    placeholder="Label"
                    :popper-append-to-body="false"
                  >
                    <el-option
                      v-for="item in lableList"
                      :key="item.labelId"
                      :label="item.labelName"
                      :value="item.labelId"
                    ></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="Stake >=">
                  <el-input v-model="queryData.minStake" clearable placeholder="input"></el-input>
                </el-form-item>
                <el-form-item label="P/L >=">
                  <el-input v-model="queryData.minProfit" clearable placeholder="input"></el-input>
                </el-form-item>
                <el-form-item label="P/L% >=">
                  <el-input v-model="queryData.minProfitPercentage" clearable placeholder="input">
                    <template slot="append">%</template>
                  </el-input>
                </el-form-item>
                <el-form-item label="Rejected/Bets% >=">
                  <el-input v-model="queryData.minRejectPercentage" clearable placeholder="input">
                    <template slot="append">%</template>
                  </el-input>
                </el-form-item>
                <el-form-item label="Bets >=">
                  <el-input v-model="queryData.minBets" clearable placeholder="input"></el-input>
                </el-form-item>
                <!-- <el-form-item label="Bets(Odds <= 1.7) >=">
                  <el-input v-model="queryData.minLowBets" clearable placeholder="input"></el-input>
                </el-form-item>-->
                <el-form-item>
                  <el-button class="search-btn" :loading="loading" @click="handleQuery()">Search</el-button>
                  <el-button class="clear-btn" @click="handleClear()">Clear</el-button>
                  <el-button class="clear-btn" @click="handleSaveQuery()">
                    <i class="iconfont icona-Property1baocun"></i> Save
                  </el-button>
                  <span class="GMT-text">Statistics are based on GMT-4</span>
                </el-form-item>
              </div>
            </el-form>
          </div>
        </div>
      </div>
      <div class="middle-btn inline-wrapper">
        <div class="middle-left">
          <!-- <el-button
            class="lebel-risk-export-btn"
            @click="isShow(1,'Batch Modifying Label')"
          >Add Label</el-button>
          <el-button
            class="lebel-risk-export-btn"
            @click="isShow(2,'Batch Modifying User Limit')"
          >Modify User Limit</el-button>-->
        </div>
        <div class="inline-right middle-left">
          <el-button
            class="lebel-risk-export-btn"
            id="download"
            @click="handleExport()"
            :loading="exportLoading"
          >
            <i class="icon iconfont iconProperty1xiazai"></i>
            Export
          </el-button>
        </div>
      </div>
      <div class="ranking-table">
        <el-table
          ref="table"
          :data="list"
          :height="tableHeight"
          v-loading="loading"
          :default-sort="{prop:'totalProfit', order:'ascending'}"
          @sort-change="sortChange"
          header-row-class-name="table-header-row"
          border
          stripe
        >
          <template slot="empty">
            <Empty />
          </template>
          <!-- <el-table-column type="selection" align="center" width="36"></el-table-column> -->
          <el-table-column label="Time" min-width="148">
            <template v-slot="{row}">
              <div v-if="timeType == 'daterange'">
                <p>{{ formatUtc(row.reportDate,1) }}</p>
                {{ formatUtc(row.reportDateEnd,2) }}
              </div>
              <div v-if="timeType == 'weekrange'">
                <p>{{ formatUtc(row.reportDate,1) }}</p>
                {{ formatUtc(row.reportDateEnd,2) }}
              </div>
              <div v-if="timeType == 'monthrange'">
                <p>{{ formatUtcYM(row.reportDate,1) }}</p>
                {{ formatUtcYM(row.reportDateEnd,2) }}
              </div>
            </template>
          </el-table-column>
          <el-table-column label="User ID / Channel" min-width="130">
            <template v-slot="{row}">
              <div
                style="cursor: pointer;"
                class="ranking-text-btn"
                @click="goUserDetail(row.userId, row.levelId)"
              >
                <p>{{row.userId}}</p>
                <p
                  style="display: inline-block;background: #2f4162;color: #fff;padding: 2px 4px;border-radius: 10px;"
                >{{row.merchantName}}</p>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="Level" prop="userLevelName" min-width="120" align="center"></el-table-column>
          <el-table-column label="Level Update Time" min-width="148">
            <template v-slot="{row}">{{ formatUtcMs(row.userLevelUpdateTime) }}</template>
          </el-table-column>
          <el-table-column
            label="Label"
            prop="labelName"
            min-width="150"
            align="left"
            :show-overflow-tooltip="true"
          >
            <template v-slot="{row}">{{ getLabelNames(row)}}</template>
          </el-table-column>
          <!-- <el-table-column label="Label" min-width="125" align="center" show-overflow-tooltip>
            <template v-slot="{row}">
              <el-button type="text" @click="isShow(8,'',row,true)" class="label-btn">
                <span v-for="item in row.labelList" :key="item.id">{{item.labelName}},</span>
              </el-button>
            </template>
          </el-table-column>-->
          <!-- <el-table-column label="User Limit" prop="levelName" align="center" min-width="118">
            <template v-slot="{row}">
              <div>
                <el-select
                  v-model="row.levelName"
                  placeholder="Select"
                  popper-class="table-select"
                  @change="selectRiskChange(row)"
                >
                  <el-option
                    v-for="item in riskLevelList"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id"
                  ></el-option>
                </el-select>
              </div>
            </template>
          </el-table-column>-->
          <el-table-column label="User Limit" prop="levelName" min-width="140" align="left">
            <template v-slot="{row}">
              <div>
                <span class="odds-tag" v-if="row.levelSource == 2">C</span>
                <span
                  class="odds-tag"
                  v-if="row.levelIdByFb && Number(row.levelIdByFb) !== Number(row.originalLevelId) && Number(row.levelSource) !== 2"
                >M</span>
                <span>{{ row.levelName }}</span>
              </div>
            </template>
          </el-table-column>
          <!-- <el-table-column label="Trend" align="center" min-width="84">
            <template v-slot="{row}">
              <el-button type="text" :disabled="row.dateType == 1" @click="handleViewChart(5,row)">
                <i class="iconfont iconqushi"></i>
              </el-button>
            </template>
          </el-table-column>-->
          <el-table-column label="Last Bet Time" min-width="148">
            <template v-slot="{row}">{{ formatUtcMs(row.lastBetTime) }}</template>
          </el-table-column>
          <el-table-column
            label="Stake"
            sortable="custom"
            prop="totalStake"
            min-width="90"
            align="right"
          >
            <template v-slot="{row}">{{ formatAmountHtml(row.totalStake) }}</template>
          </el-table-column>
          <el-table-column
            label="P/L"
            sortable="custom"
            prop="totalProfit"
            min-width="90"
            align="right"
          >
            <template v-slot="{row}">{{ formatAmountHtml(row.totalProfit) }}</template>
          </el-table-column>
          <el-table-column
            label="P/L%"
            sortable="custom"
            prop="totalPl"
            min-width="90"
            align="right"
          >
            <template v-slot="{row}">
              <div>{{ formatNumber(row.totalPl) }}%</div>
            </template>
          </el-table-column>
          <el-table-column label="Bets" sortable="custom" prop="bets" min-width="80" align="right"></el-table-column>
          <el-table-column
            label="Rejected/Bets"
            sortable="custom"
            prop="rejectPl"
            min-width="130"
            align="right"
          >
            <template v-slot="{row}">
              <div>{{ formatNumber(row.rejectPl) }}%</div>
            </template>
          </el-table-column>
          <el-table-column
            label="Cashout Bets"
            sortable="custom"
            prop="cashoutBets"
            min-width="140"
            align="right"
          ></el-table-column>
          <el-table-column
            label="Cashout Stake"
            sortable="custom"
            prop="cashoutStake"
            min-width="130"
            align="right"
          >
            <template v-slot="{row}">{{ formatAmountHtml(row.cashoutStake) }}</template>
          </el-table-column>
          <el-table-column
            label="Cashout P/L"
            sortable="custom"
            prop="cashoutProfit"
            min-width="130"
            align="right"
          >
            <template v-slot="{row}">{{ formatAmountHtml(row.cashoutProfit) }}</template>
          </el-table-column>
          <el-table-column
            label="Cashout P/L%"
            sortable="custom"
            prop="cashoutPl"
            min-width="130"
            align="right"
          >
            <template v-slot="{row}">
              <div>{{ formatNumber(row.cashoutPl) }}%</div>
            </template>
          </el-table-column>
          <el-table-column
            label="Remark"
            prop="remark"
            min-width="200"
            align="left"
            :show-overflow-tooltip="true"
          >
            <template v-slot="{row}">{{ row.remark}}</template>
          </el-table-column>
          <!-- <el-table-column
            label="Bets(Odds <= 1.7)"
            sortable="custom"
            prop="lowBets"
            min-width="150"
            align="right"
          ></el-table-column>-->
          <!-- <el-table-column
            label="Stake(Odds <= 1.7)"
            sortable="custom"
            prop="lowStake"
            min-width="150"
            align="right"
          ></el-table-column>-->
          <!-- <el-table-column
            label="P/L(Odds <= 1.7)"
            sortable="custom"
            prop="lowProfit"
            min-width="150"
            align="right"
          ></el-table-column>
          <el-table-column
            label="P/L%(Odds <= 1.7)"
            sortable="custom"
            prop="lowPl"
            min-width="155"
            align="right"
          >
            <template v-slot="{row}">
              <div>{{ formatNumber(row.lowPl) }}%</div>
            </template>
          </el-table-column>-->
        </el-table>
      </div>
      <div class="pagination-wrapper inline-wrapper">
        <el-pagination
          class="inline-right"
          :total="total"
          :current-page="queryData.current"
          :page-size="queryData.size"
          :page-sizes="[50, 100, 200]"
          @current-change="changePage"
          @size-change="handleSizeChange"
          layout="total, sizes, prev, pager, next, jumper"
        ></el-pagination>
      </div>
    </div>
    <dia ref="dialogDom" :class="['label-dialog',{'chart-dialog' : num == 5}]">
      <!-- 添加label1 修改riskLevel2 chart5-->
      <div class="select-down-wrapper">
        <el-form label-width="80px">
          <el-form-item label="User Limit:" v-if="num == 2">
            <el-select
              v-model="levelQueryData.levelId"
              placeholder="User Limit"
              :popper-append-to-body="false"
              @change="getLevel(levelQueryData.levelId)"
            >
              <el-option
                v-for="item in riskLevelList"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              ></el-option>
            </el-select>
          </el-form-item>

          <!-- <el-form-item label="Label:" v-if="num == 1 || num == 8 ">
            <el-select
              v-model="lableQueryData.labelIds"
              multiple
              :multiple-limit="10"
              collapse-tags
              placeholder="Label"
              :popper-append-to-body="false"
            >
              <el-option
                v-for="item in lableList"
                :key="item.id"
                :label="item.labelName"
                :value="item.id"
              ></el-option>
            </el-select>
          </el-form-item>-->
        </el-form>
        <div class="dialog-footer table-search-part">
          <el-button class="search-btn" @click="handleLevelAdd()" v-if="num == 2">Confirm</el-button>
          <el-button class="search-btn" @click="handleLableAdd()" v-if="num == 1">Confirm</el-button>
          <el-button class="search-btn" @click="handleLableEdit()" v-if="num == 8">Confirm</el-button>
          <el-button class="search-btn" @click="switchAlert()" v-if="num == 3">Confirm</el-button>
          <el-button class="search-btn" @click="switchBatchStatus()" v-if="num == 4">Confirm</el-button>
          <el-button class="clear-btn" @click="Close()" v-if="num != 5">Cancel</el-button>
        </div>
      </div>

      <div class="order-amount-wrapper" v-if="num == 5">
        <div class="time-range-box">
          <div class="time-range">
            <p :class="{active: type == 1}" @click="handleChange(1)">Stake</p>
            <p :class="{active: type == 2}" @click="handleChange(2)">P/L</p>
          </div>
        </div>
        <div id="orderAmount"></div>
      </div>
    </dia>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import echarts from "echarts";
import dia from "@/components/dialog/index";
import Empty from "@/components/empty/index";
import {
  getRiskLevel,
  getLableList,
  getMerchat,
  getLevelUpdate,
  getLableUpdate,
  getMemberUpdate,
  getLevelList
} from "@/api/member";
import {
  getProfitList,
  getProfitExport,
  getChartList
} from "@/api/memberDetail";
import { findAllLabel } from "@/api/lable";
const DEFAULT_DAY = 24 * 60 * 60 * 1000;
var option;
var mixoption;
option = {
  tooltip: {
    trigger: "axis",
    axisPointer: {
      // 坐标轴指示器，坐标轴触发有效
      type: "shadow", // 默认为直线，可选为：'line' | 'shadow'
      shadowStyle: {
        color: "rgba(196, 196, 196, 0.2)"
      }
    },
    backgroundColor: "#2F4162"
  },
  grid: {
    left: "3%",
    right: "3%",
    top: "3%",
    bottom: "7%",
    containLabel: true
  },
  xAxis: [
    {
      type: "category",
      data: [],
      axisLine: {
        lineStyle: {
          color: "#E7EDF6"
        }
      },
      axisTick: {
        alignWithLabel: true
      },
      axisLabel: {
        color: "#8798A9", // 刻度标签文字的颜色
        fontSize: "12" // 文字字体大小
      }
    }
  ],
  yAxis: [
    {
      type: "value",
      axisLine: {
        lineStyle: {
          color: "#E7EDF6" // 坐标轴线线的颜色
        }
      },
      axisTick: {
        alignWithLabel: true
      },
      axisLabel: {
        color: "#8798A9",
        fontSize: "12"
      },
      splitLine: {
        //设置网格线颜色
        lineStyle: {
          color: ["#E7EDF6"],
          width: 1,
          type: "solid"
        }
      }
    }
  ],
  series: [
    {
      name: "Stake",
      type: "bar",
      barWidth: 7,
      itemStyle: {
        emphasis: {
          barBorderRadius: [7, 7, 0, 0]
        },
        normal: {
          color: "#E1554F",
          barBorderRadius: [7, 7, 0, 0]
        }
      },
      data: []
    }
  ]
};

mixoption = {
  tooltip: {
    trigger: "axis",
    axisPointer: {
      // 坐标轴指示器，坐标轴触发有效
      type: "shadow", // 默认为直线，可选为：'line' | 'shadow'
      shadowStyle: {
        color: "rgba(196, 196, 196, 0.2)"
      }
    },
    backgroundColor: "#2F4162"
  },
  legend: {
    itemWidth: 8,
    itemHeight: 8,
    itemGap: 25,
    icon: "circle",
    data: [
      {
        name: "P/L",
        textStyle: {
          color: "#8798A9"
        }
      },
      {
        name: "P/L%",
        textStyle: {
          color: "#8798A9"
        }
      }
    ],
    bottom: 0
  },
  grid: {
    left: "3%",
    right: "3%",
    top: "3%",
    bottom: "8%",
    containLabel: true
  },
  xAxis: [
    {
      type: "category",
      axisTick: {
        show: false
      },
      axisLine: {
        lineStyle: {
          color: "#E7EDF6"
        }
      },
      axisLabel: {
        color: "#8798A9",
        fontSize: "12"
      }
    }
  ],
  yAxis: [
    {
      type: "value",
      // name: 'P/L',
      splitNumber: 5,
      axisLine: {
        lineStyle: {
          color: "#E7EDF6"
        }
      },
      axisLabel: {
        color: "#8798A9",
        fontSize: "12"
      },
      splitLine: {
        //设置网格线颜色
        lineStyle: {
          color: ["#E7EDF6"],
          width: 1,
          type: "solid"
        }
      },
      data: []
    },
    {
      type: "value",
      // name: 'P/L%',
      splitNumber: 5,
      axisLine: {
        lineStyle: {
          color: "#E7EDF6"
        }
      },
      axisLabel: {
        color: "#8798A9",
        fontSize: "12",
        formatter: "{value}%"
      },
      splitLine: {
        //设置网格线颜色
        lineStyle: {
          color: ["#E7EDF6"],
          width: 1,
          type: "solid"
        }
      },
      data: []
    }
  ],
  series: [
    {
      name: "P/L",
      type: "bar",
      barWidth: 7,
      emphasis: {
        focus: "series"
      },
      data: []
    },
    {
      name: "P/L%",
      type: "line",
      emphasis: {
        focus: "series"
      },
      showSymbol: false, // false 在 tooltip时显示
      symbolSize: 1, //设定实心点的大小
      itemStyle: {
        emphasis: {
          // 鼠标经过时
          borderWidth: 2,
          borderColor: "#4690FF"
        },
        normal: {
          // 静止时
          lineStyle: { color: "#4690FF" }
        }
      },
      yAxisIndex: 1,
      data: []
    }
  ]
};

export default {
  name: "RankingList",
  data() {
    return {
      userLevelUpdateTime: [],
      partnerSelect: [], // 合伙商列表
      masterDistributorSelect: [], // 总经销列表
      distributorSelect: [], // 经销商
      companySelect: [], // 公司
      ChannelType: 1,
      exportLoading: false,
      partner: "",
      masterDistributor: "",
      distributor: "",
      company: "",
      agentList: [
        { id: 1, val: false, name: "All" },
        { id: 2, val: true, name: "Directly Channel" }
      ],
      betList: [
        { id: 0, val: false, name: "All" },
        { id: 1, val: true, name: "Single" },
        { id: 2, val: true, name: "Parlay" }
      ],
      list: [],
      riskLevelList: [],
      lableList: [],
      levelList: [],
      merchatList: [],
      fastData: "24 Hours",
      freeDate: [],
      chooseDate: [],
      weekEndValue: "",
      weekStartValue: "",
      startStamp: "",
      endStamp: "",
      monthDate: [],
      timeType: "daterange",
      date: "",
      firstActive: false,
      loading: false,
      queryData: {
        userLevelIds: [],
        period: 24,
        current: 1,
        seriesType: 0,
        labelIds: [],
        userLevelUpdateStartTime: "",
        userLevelUpdateEndTime: "",
        //labelIds: "",
        levelId: "",
        size: 50,
        dateType: 2,
        rankFieldType: 1,
        startTime: "",
        endTime: "",
        ascSort: false,
        minBets: null,
        minStake: null,
        minProfit: null,
        minLowBets: null,
        minProfitPercentage: null,
        minRejectPercentage: null,
        channelId: null
      },
      levelQueryData: {
        userIds: [],
        levelIds: [],
        levelId: ""
      },
      lableQueryData: {
        userIds: [],
        labelIds: []
      },
      total: 0,
      tableHeight: window.innerHeight,
      offset: 0,
      multipleSelection: [],
      num: "",
      title: "Batch Modifying Label",
      curDate: "",
      pickerOptions: {
        onPick: ({ maxDate, minDate }) => {
          this.selectDate = minDate.getTime();
          if (maxDate) {
            this.selectDate = "";
          }
        },
        disabledDate: time => {
          if (this.selectDate !== "") {
            const one = 6 * 24 * 3600 * 1000;
            const minTime = this.selectDate - one;
            const maxTime = this.selectDate + one;
            return time.getTime() < minTime || time.getTime() > maxTime;
          }
        }
      },
      settleStartDate: "",
      settleEndDate: "",
      pickerEndDateOptions: {
        disabledDate: time => {
          let startH = new Date(this.settleStartDate).getHours();
          if (+startH > 18) {
            return (
              time.getTime() >
                this.$moment(this.settleStartDate)
                  .add(1, "days")
                  .hours(0)
                  .minutes(0)
                  .seconds(0)
                  .valueOf() ||
              time.getTime() <
                this.$moment(this.settleStartDate)
                  .add(1, "days")
                  .hours(0)
                  .minutes(0)
                  .seconds(0)
                  .valueOf()
            );
          } else {
            return (
              time.getTime() >
                this.$moment(this.settleStartDate)
                  .hours(0)
                  .minutes(0)
                  .seconds(0)
                  .valueOf() ||
              time.getTime() <
                this.$moment(this.settleStartDate)
                  .hours(0)
                  .minutes(0)
                  .seconds(0)
                  .valueOf()
            );
          }
        }
      },
      pickerStartDateOptions: {
        selectableRange: [
          "00:00:00 - 00:00:00",
          "06:00:00 - 06:00:00",
          "12:00:00 - 12:00:00",
          "18:00:00 - 18:00:00"
        ]
      },
      chartQueryData: {
        period: 24,
        userId: null
      },
      orderChart: null,
      PLChart: null,
      type: 1,
      isFirstTime: false
    };
  },
  methods: {
    formatAmountHtml(value) {
      let amount = Number(value).toFixed(2);
      amount = amount.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      return amount;
    },
    // merchant下拉框
    async fetchMerchantList() {
      let paramData = {};
      const res = await getMerchat(paramData);
      let data = res.data || {};

      this.merchantParserData = this.parserMerchantSelectedHttpResponse(res);
      this.merchatList = this.objToArray(this.merchantParserData.channels);
      this.partnerSelect = this.objToArray(this.merchantParserData.level1);
      this.masterDistributorSelect = this.objToArray(
        this.merchantParserData.level2
      );
      this.distributorSelect = this.objToArray(this.merchantParserData.level3);
      this.companySelect = this.objToArray(this.merchantParserData.level4);
    },
    //最新改为前端处理
    objToArray(obj) {
      if (Array.isArray(obj)) {
        return obj;
      }
      let arr = [];
      for (let key in obj) {
        let objIten = {
          id: key,
          name: obj[key].name
        };
        arr.push(objIten);
      }
      return arr;
    },
    queryLevelFromArray(localMerchantData, agents, level) {
      for (const agent of agents) {
        // 如果本地没有 agent 数据, 初始化本地数据
        if (!localMerchantData[`level${agent.level}`][agent.id]) {
          localMerchantData[`level${agent.level}`][agent.id] = {
            name: agent.name,
            childs: {},
            channels: {},
            directlyChannels: {}
          };
        }
        if (agent.level == level) {
          return {
            id: agent.id,
            name: agent.name
          };
        }
      }
      return null;
    },

    setChildAgent(localMerchantData, level, parent, child) {
      let parentLevel = localMerchantData[`level${level}`];
      let childLevel = localMerchantData[`level${level + 1}`];
      if (!parent || !child) {
        return;
      }
      parentLevel[parent.id].childs[child.id] = child.name;
      childLevel[child.id].parentId = parent.id;
    },

    setAgentChannel(agentLevel, agent, channel) {
      if (!agent || !agentLevel[[agent.id]]) {
        return;
      }
      agentLevel[agent.id].channels[channel.id] = channel.name;
    },

    parserMerchantSelectedHttpResponse(response) {
      let localMerchantData = {
        level1: {},
        level2: {},
        level3: {},
        level4: {},
        channels: {}
      };
      for (const merchantData of response.data) {
        let channel = {
          name: merchantData.name,
          agents: [
            this.queryLevelFromArray(localMerchantData, merchantData.agents, 1),
            this.queryLevelFromArray(localMerchantData, merchantData.agents, 2),
            this.queryLevelFromArray(localMerchantData, merchantData.agents, 3),
            this.queryLevelFromArray(localMerchantData, merchantData.agents, 4)
          ]
        };

        localMerchantData.channels[merchantData.id] = channel;

        let simpleChannel = { id: merchantData.id, name: channel.name };

        // 配置商户底下的渠道
        this.setAgentChannel(
          localMerchantData.level1,
          channel.agents[0],
          simpleChannel
        );
        this.setAgentChannel(
          localMerchantData.level2,
          channel.agents[1],
          simpleChannel
        );
        this.setAgentChannel(
          localMerchantData.level3,
          channel.agents[2],
          simpleChannel
        );
        this.setAgentChannel(
          localMerchantData.level4,
          channel.agents[3],
          simpleChannel
        );

        // 配置商户阶层关系的渠道
        this.setChildAgent(
          localMerchantData,
          1,
          channel.agents[0],
          channel.agents[1]
        );
        this.setChildAgent(
          localMerchantData,
          2,
          channel.agents[1],
          channel.agents[2]
        );
        this.setChildAgent(
          localMerchantData,
          3,
          channel.agents[2],
          channel.agents[3]
        );

        for (let i = channel.agents.length; i > 0; i--) {
          if (channel.agents[i - 1] != null) {
            let agent = channel.agents[i - 1];
            localMerchantData[`level${i}`][agent.id].directlyChannels[
              merchantData.id
            ] = merchantData.name;
            break;
          }
        }
      }

      return localMerchantData;
    },

    getDirectChinnel(agentLevel, directlyChannel = false) {
      let channels = [];
      let x = directlyChannel
        ? agentLevel.directlyChannels
        : agentLevel.channels;
      for (const [channelId, channelName] of Object.entries(x)) {
        channels.push({
          id: channelId.toString(),
          name: channelName
        });
      }
      return channels;
    },

    getDirectAgent(localMerchantData, level, agentId) {
      let childAgents = [];
      let childs =
        level > 0
          ? localMerchantData[`level${level}`][agentId].childs
          : localMerchantData[`level1`];
      for (const [childAgentId, childAgentName] of Object.entries(childs)) {
        childAgents.push({
          id: childAgentId.toString(),
          name: childAgentName.name || childAgentName
        });
      }
      return childAgents;
    },

    chooseLevelMerchant(
      localMerchantData,
      level,
      agentId,
      directlyChannel = false
    ) {
      let result = {
        chooseLevel1: null,
        chooseLevel2: null,
        chooseLevel3: null,
        chooseLevel4: null,
        chooseChannel: null,
        level1: [],
        level2: [],
        level3: [],
        level4: [],
        channels: []
      };

      let chooseAgent = null;
      let currentLevel = null;

      if (level >= 5) {
        // 给定指定渠道
        let channel = localMerchantData[`channels`][agentId];
        let chooseChannel = {
          id: agentId.toString(),
          name: channel.name
        };
        result[`chooseChannel`] = chooseChannel;
        channel.agents.forEach((agent, index) => {
          if (!agent) {
            return;
          }
          level = index + 1;
          agentId = agent.id;
        });
      }

      if (level > 0 && level < 5) {
        chooseAgent = {
          id: agentId.toString(),
          name: localMerchantData[`level${level}`][agentId].name
        };

        // 给定当前等级
        result[`chooseLevel${level}`] = chooseAgent;

        currentLevel = level;
        let currentAgentId = agentId;
        // 给定父级
        while (currentLevel > 1) {
          let parentId =
            localMerchantData[`level${currentLevel}`][currentAgentId].parentId;
          let parent = {
            id: parentId.toString(),
            name: localMerchantData[`level${currentLevel - 1}`][parentId].name
          };
          result[`chooseLevel${currentLevel - 1}`] = parent;
          let currentLevelAgents = this.getDirectAgent(
            localMerchantData,
            currentLevel - 1,
            parentId
          );
          result[`level${currentLevel}`] = currentLevelAgents;

          currentLevel -= 1;
          currentAgentId = parentId;
        }
      }

      let level1Agents = this.getDirectAgent(localMerchantData, 0);
      result[`level1`] = level1Agents;

      // 给定子级跟渠道
      if (level > 0 && level < 5) {
        result.channels = result.channels.concat(
          this.getDirectChinnel(
            localMerchantData[`level${level}`][agentId],
            directlyChannel
          )
        );
      }
      currentLevel = null;
      let currentAgents = null;
      if (level == 0) {
        let currentLevelAgents = this.getDirectAgent(localMerchantData, 0);
        result[`level1`] = currentLevelAgents;

        for (const [agentId, agentLevel] of Object.entries(
          localMerchantData[`level${level + 1}`]
        )) {
          result.channels = result.channels.concat(
            this.getDirectChinnel(
              localMerchantData[`level${level + 1}`][agentId]
            )
          );
        }
        currentLevel = 1;
        currentAgents = result[`level1`];
      } else {
        currentAgents = [result[`chooseLevel${level}`]];
        currentLevel = level;
      }

      while (currentLevel < 4) {
        for (const agent of currentAgents) {
          for (const [childId, childName] of Object.entries(
            localMerchantData[`level${currentLevel}`][agent.id].childs
          )) {
            result[`level${currentLevel + 1}`].push({
              id: childId.toString(),
              name: childName
            });
          }
        }
        currentLevel += 1;
        currentAgents = result[`level${currentLevel}`];
      }
      return result;
    },
    agentChange(val) {
      this.queryData.channelId = "";
      this.merchatList = [];
      this.partner = "";
      this.partnerSelect = [];
      this.masterDistributor = "";
      this.masterDistributorSelect = [];
      this.distributor = "";
      this.distributorSelect = [];
      this.company = "";
      this.companySelect = [];
      this.merchatList = this.objToArray(this.merchantParserData.channels);
      this.partnerSelect = this.objToArray(this.merchantParserData.level1);
      this.masterDistributorSelect = this.objToArray(
        this.merchantParserData.level2
      );
      this.distributorSelect = this.objToArray(this.merchantParserData.level3);
      this.companySelect = this.objToArray(this.merchantParserData.level4);
    },
    formatOptionData(filterMerchantData) {
      const {
        level1,
        level2,
        level3,
        level4,
        chooseLevel1,
        chooseLevel2,
        chooseLevel3,
        chooseLevel4,
        channels
      } = filterMerchantData;
      this.partnerSelect = level1 || [];
      this.masterDistributorSelect = level2 || [];
      this.distributorSelect = level3 || [];
      this.companySelect = level4 || [];
      this.partner = chooseLevel1?.id || "";
      this.masterDistributor = chooseLevel2?.id || "";
      this.distributor = chooseLevel3?.id || "";
      this.company = chooseLevel4?.id || "";
      this.merchatList = channels;
    },
    merchantIdChange(val) {
      if (!val) {
        return;
      }
      let status = this.ChannelType == 1 ? false : true;
      let filterMerchantData = this.chooseLevelMerchant(
        this.merchantParserData,
        5,
        val,
        status
      );
      this.formatOptionData(filterMerchantData);
    },
    //level 1
    partnerChange(val) {
      this.masterDistributor = "";
      this.masterDistributorSelect = [];
      this.distributor = "";
      this.distributorSelect = [];
      this.company = "";
      this.companySelect = [];
      this.queryData.channelId = "";
      if (!val) {
        this.merchatList = this.objToArray(this.merchantParserData.channels);
        this.partnerSelect = this.objToArray(this.merchantParserData.level1);
        this.masterDistributorSelect = this.objToArray(
          this.merchantParserData.level2
        );
        this.distributorSelect = this.objToArray(
          this.merchantParserData.level3
        );
        this.companySelect = this.objToArray(this.merchantParserData.level4);
        return;
      }

      if (val) {
        let status = this.ChannelType == 1 ? false : true;
        let filterMerchantData = this.chooseLevelMerchant(
          this.merchantParserData,
          1,
          val,
          status
        );
        this.formatOptionData(filterMerchantData);
      }
    },
    //level 2
    masterDistributorChange(val) {
      this.distributor = "";
      this.distributorSelect = [];
      this.company = "";
      this.companySelect = [];
      this.queryData.channelId = "";
      if (!val) {
        let status = this.ChannelType == 1 ? false : true;
        let filterMerchantData = this.chooseLevelMerchant(
          this.merchantParserData,
          1,
          this.partner,
          status
        );
        this.merchatList = this.objToArray(filterMerchantData.channels);
        this.masterDistributorSelect = this.objToArray(
          this.merchantParserData.level2
        );
        this.distributorSelect = this.objToArray(
          this.merchantParserData.level3
        );
        this.companySelect = this.objToArray(this.merchantParserData.level4);
        return;
      }
      if (val) {
        let status = this.ChannelType == 1 ? false : true;
        let filterMerchantData = this.chooseLevelMerchant(
          this.merchantParserData,
          2,
          val,
          status
        );
        this.formatOptionData(filterMerchantData);
      }
    },
    //level 3
    distributorChange(val) {
      this.company = "";
      this.companySelect = [];
      this.queryData.channelId = "";
      if (!val) {
        let status = this.ChannelType == 1 ? false : true;
        let filterMerchantData = this.chooseLevelMerchant(
          this.merchantParserData,
          2,
          this.masterDistributor,
          status
        );
        this.merchatList = this.objToArray(filterMerchantData.channels);
        this.distributorSelect = this.objToArray(
          this.merchantParserData.level3
        );
        this.companySelect = this.objToArray(this.merchantParserData.level4);
        return;
      }
      if (val) {
        let status = this.ChannelType == 1 ? false : true;
        let filterMerchantData = this.chooseLevelMerchant(
          this.merchantParserData,
          3,
          val,
          status
        );
        this.formatOptionData(filterMerchantData);
      }
    },
    //level 4
    companyChange(val) {
      this.queryData.channelId = "";
      if (!val) {
        let status = this.ChannelType == 1 ? false : true;
        let filterMerchantData = this.chooseLevelMerchant(
          this.merchantParserData,
          3,
          this.distributor,
          status
        );
        this.merchatList = this.objToArray(filterMerchantData.channels);
        this.companySelect = this.objToArray(this.merchantParserData.level4);
        return;
      }
      if (val) {
        let status = this.ChannelType == 1 ? false : true;
        let filterMerchantData = this.chooseLevelMerchant(
          this.merchantParserData,
          4,
          val,
          status
        );
        this.formatOptionData(filterMerchantData);
      }
    },
    async getList(rightTime) {
      // !rightTime ? this.queryData.startTime = (this.queryData.startTime + this.offset * 60 * 1000) - 4 * 60 * 60 * 1000 : this.queryData.startTime
      // !rightTime ? this.queryData.endTime = (this.queryData.endTime + this.offset * 60 * 1000) - 4 * 60 * 60 * 1000 : this.queryData.endTime
      if (this.userLevelUpdateTime) {
        this.queryData.userLevelUpdateStartTime = this.userLevelUpdateTime[0];
        this.queryData.userLevelUpdateEndTime = this.userLevelUpdateTime[1];
      } else {
        this.queryData.userLevelUpdateStartTime = "";
        this.queryData.userLevelUpdateEndTime = "";
      }
      if (this.timeType == "daterange") {
        this.queryData.startTime =
          this.chooseDate[0] - this.offset * 60 * 1000 + 4 * 60 * 60 * 1000;
        this.queryData.endTime =
          this.chooseDate[1] - this.offset * 60 * 1000 + 4 * 60 * 60 * 1000;
      } else if (this.timeType == "weekrange") {
        if (!this.startStamp) {
          this.$message({ message: "Please Must Start Time", type: "warning" });
          return;
        }
        if (!this.endStamp) {
          this.$message({ message: "Please Must End Time", type: "warning" });
          return;
        }
        if (this.startStamp >= this.endStamp) {
          this.$message({
            message: "Start Time Greater Than End Time",
            type: "warning"
          });
          return;
        }

        this.queryData.startTime =
          this.startStamp - this.offset * 60 * 1000 + 4 * 60 * 60 * 1000;
        this.queryData.endTime =
          this.endStamp - this.offset * 60 * 1000 + 4 * 60 * 60 * 1000;
      } else {
        this.queryData.startTime =
          this.monthDate[0] - this.offset * 60 * 1000 + 4 * 60 * 60 * 1000;
        this.queryData.endTime =
          this.monthDate[1] - this.offset * 60 * 1000 + 4 * 60 * 60 * 1000;
      }

      if (!this.chooseDate.length > 0) {
        this.$message({ message: "Time Must checked one", type: "warning" });
        return false;
      }
      this.loading = true;
      try {
        let minProfitPercentage = Number(this.queryData.minProfitPercentage)
          ? Number(this.queryData.minProfitPercentage) / 100
          : "";
        let minRejectPercentage = Number(this.queryData.minRejectPercentage)
          ? Number(this.queryData.minRejectPercentage) / 100
          : "";
        let merchantId = "";
        if (this.masterDistributor) {
          merchantId = this.masterDistributor;
        } else if (this.partner) {
          merchantId = this.partner;
        }

        let param = {
          ...this.queryData,
          minProfitPercentage: minProfitPercentage,
          minRejectPercentage: minRejectPercentage,
          merchantId: merchantId
        };
        const res = await getProfitList(param, 0, { timeout: 120000 });
        const data = res.data || {};
        this.list = data.records || [];
        this.total = data.total;
        this.loading = false;
      } catch (error) {
        this.list = [];
        this.loading = false;
      }
    },
    getLabelNames(row) {
      let { labelIds } = row;
      let labelArr = labelIds ? labelIds : [];
      let IdsArr = labelArr.map(i => {
        return i;
      });
      let str = "";
      this.lableList.map(item => {
        if (IdsArr.includes(item.labelId)) {
          str += item.labelName;
          str += "、";
        }
      });
      str = str.slice(0, -1); // 移除最后一个逗号
      return str;
    },
    handCommand(timeType) {
      if (timeType == "monthrange") {
        this.queryData.period = 100;
      } else if (timeType == "weekrange") {
        this.queryData.period = 50;
        this.weekStartValue = new Date(
          new Date().toLocaleDateString()
        ).getTime();
        this.weekEndValue = new Date(new Date().toLocaleDateString()).getTime();
        this.startStamp =
          new Date(new Date().toLocaleDateString()).getTime() -
          (new Date().getDay() - 1) * 24 * 60 * 60 * 1000;
        this.endStamp =
          new Date(new Date().toLocaleDateString()).getTime() -
          (new Date().getDay() - 1) * 24 * 60 * 60 * 1000 +
          7 * 24 * 60 * 60 * 1000 -
          1;
      } else {
        this.queryData.period = 24;
      }
      this.timeType = timeType;
      //this.masterDistributor = "";
      this.queryData.dateType = timeType == "daterange" ? 2 : 1;
      this.changeMonth(this.queryData.dateType);
      this.getList();
    },

    dataPickChange() {
      this.changeMonth(this.queryData.dateType);
    },
    changeMonth(dateType) {
      if (dateType == 2) {
        const start = this.$moment(this.chooseDate[0]).startOf("day"); //  当月第一天时间
        const end = this.$moment(this.chooseDate[1]).endOf("day"); //  当月最后一天
        this.chooseDate = [start.valueOf(), end.valueOf()];
      } else {
        const start = this.$moment(this.monthDate[0]).startOf("month"); //  当月第一天时间
        const end = this.$moment(this.monthDate[1]).endOf("month"); //  当月最后一天
        this.monthDate = [start.valueOf(), end.valueOf()];
      }
    },
    async handleExport() {
      try {
        this.exportLoading = true;

        let minProfitPercentage = Number(this.queryData.minProfitPercentage)
          ? Number(this.queryData.minProfitPercentage) / 100
          : "";
        let minRejectPercentage = Number(this.queryData.minRejectPercentage)
          ? Number(this.queryData.minRejectPercentage) / 100
          : "";

        if (this.multipleSelection.length > 0) {
          // this.queryData.userIds = Object.values(this.multipleSelection).map(
          //   el => el.userId
          // );
        }
        let merchantId = "";
        if (this.masterDistributor) {
          merchantId = this.masterDistributor;
        } else if (this.partner) {
          merchantId = this.partner;
        }

        let param = {
          ...this.queryData,
          minProfitPercentage: minProfitPercentage,
          minRejectPercentage: minRejectPercentage,
          merchantId: merchantId
        };

        // 使用 await 等待 getProfitExport 函数执行完成
        await getProfitExport(param, "export.xlsx");

        // getProfitExport 函数执行完成后，设置 loading 为 false
        this.exportLoading = false;
      } catch (error) {
        console.error(error);
        this.exportLoading = false;
      }
    },
    sortChange(column) {
      this.queryData.ascSort = column.order == "descending" ? false : true;
      if (column.column.label == "P/L") {
        this.queryData.rankFieldType = 1;
      } else if (column.column.label == "Bets") {
        this.queryData.rankFieldType = 9;
      } else if (column.column.label == "Stake") {
        this.queryData.rankFieldType = 3;
      } else if (column.column.label == "P/L%") {
        this.queryData.rankFieldType = 13;
      } else if (column.column.label == "Stake(Odds <= 1.7)") {
        this.queryData.rankFieldType = 5;
      } else if (column.column.label == "P/L(Odds <= 1.7)") {
        this.queryData.rankFieldType = 6;
      } else if (column.column.label == "Bets(Odds <= 1.7)") {
        this.queryData.rankFieldType = 7;
      } else if (column.column.label == "P/L%(Odds <= 1.7)") {
        this.queryData.rankFieldType = 14;
      } else if (column.column.label == "Cashout P/L") {
        this.queryData.rankFieldType = 2;
      } else if (column.column.label == "Cashout Stake") {
        this.queryData.rankFieldType = 10;
      } else if (column.column.label == "Cashout Bets") {
        this.queryData.rankFieldType = 12;
      } else if (column.column.label == "Cashout P/L%") {
        this.queryData.rankFieldType = 15;
      } else if (column.column.label == "Rejected/Bets") {
        this.queryData.rankFieldType = 16;
      }
      this.getList(true);
    },
    changeStartTime(val) {
      if (val) {
        let timeStamp = val.getTime() - 24 * 60 * 60 * 1000;
        this.startStamp = timeStamp;
      } else {
        this.startStamp = "";
      }
    },
    changeEndTime(val) {
      if (val) {
        let timeStamp = val.getTime() - 24 * 60 * 60 * 1000;
        this.endStamp = timeStamp + 7 * 24 * 60 * 60 * 1000 - 1;
      } else {
        this.endStamp = "";
      }
    },
    // 搜索
    handleQuery() {
      this.queryData.current = 1;
      this.getList(this.isFirstTime);
      this.isFirstTime = true;
    },
    // 跳转详情
    goUserDetail(userId, levelId) {
      this.$router.push({
        path: "/member/detail",
        query: { userId: userId, levelId: levelId }
      });
    },
    // 分页
    changePage(e) {
      this.queryData.current = e;
      this.getList(true);
    },
    // 列表显示条目
    handleSizeChange(e) {
      this.queryData.size = e;
      this.queryData.current = 1;
      this.getList(true);
    },
    // lable下拉框
    async getLableList() {
      const res = await findAllLabel();
      let data = res.data || {};
      this.lableListAll = data;
      this.lableList = data.filter(label => label.labelId > 100028);
    },
    async getLevelList() {
      const res = await getLevelList({});
      let data = res.data || [];
      this.levelList = data;
    },
    async getRiskLevel() {
      const res = await getRiskLevel();
      let data = res.data || {};
      this.riskLevelList = this.getArray(data);
    },
    getArray(data) {
      return Object.keys(data).map(el => {
        return {
          id: el,
          name: data[el]
        };
      });
    },
    // 表格选中
    // handleSelectionChange(val) {
    //   this.multipleSelection = val;
    // },
    isShow(num, title, data, isInTable) {
      if (this.multipleSelection.length > 0 || isInTable) {
        this.levelQueryData.userIds = Object.values(this.multipleSelection).map(
          el => el.userId
        );
        this.levelQueryData.levelIds = Object.values(
          this.multipleSelection
        ).map(el => el.levelId);
        this.lableQueryData.userIds = isInTable
          ? [data.userId]
          : Object.values(this.multipleSelection).map(el => el.userId);
        if (data) {
          let roleNameArr = data.labelList || [];
          let roleIdsArr = roleNameArr
            ? roleNameArr.map(item => {
                return item.id;
              })
            : [];
          roleIdsArr.forEach((id, index) => {
            if (!this.lableList.find(r => r.id === id))
              return {
                id,
                labelName: roleNameArr[index].labelName
              };
          });
          this.lableQueryData.labelIds = roleIdsArr;
        } else {
          this.lableQueryData.labelIds = [];
        }
        this.num = num;
        this.title = title;
        this.$refs["dialogDom"].isShowDia(this.title, true, "323px");
      } else {
        this.$message({ message: "Must checked one", type: "warning" });
      }
    },
    getLevel(e) {
      this.levelQueryData.levelId = e;
    },
    // 添加risk elvel
    async handleLevelAdd(data) {
      delete this.levelQueryData.levelIds;
      const res = await getLevelUpdate(this.levelQueryData);
      this.Close();
      this.levelQueryData.levelId = "";
      this.getList(true);
    },
    // 添加label
    async handleLableAdd(data) {
      const res = await getLableUpdate(this.lableQueryData);
      this.Close();
      this.lableQueryData.labelIds = [];
      this.getList(true);
    },
    async handleLableEdit(data) {
      let userId = this.lableQueryData.userIds[0];
      let labelIds = this.lableQueryData.labelIds;
      let param = { labelIds, userId };
      const res = await getMemberUpdate(param);
      this.Close();
      this.lableQueryData.labelIds = [];
      this.getList(true);
    },
    Close() {
      this.levelQueryData.levelId = "";
      this.lableQueryData.labelIds = [];
      this.$refs["dialogDom"].isShowDia(this.title, false, "323px");
    },
    selectRiskChange(val) {
      this.levelQueryData.userIds = [val.userId];
      this.levelQueryData.levelId = val.levelName;
      this.levelQueryData.levelIds = [val.levelId];
      this.handleLevelAdd();
    },
    handleChangeStartDate(val) {
      this.isFirstTime = false;
      this.queryData.endTime = this.settleEndDate =
        this.$moment(this.settleStartDate).valueOf() + 6 * 3600 * 1000 - 1;
      let startH = new Date(val).getHours();
      let startM = new Date(val).getMinutes();
      let startS = new Date(val).getSeconds();
      let end = new Date(val).getTime() + 6 * 3600 * 1000 + 1;
      let endH = new Date(end).getHours();
      let endM = new Date(end).getMinutes();
      let endS = new Date(end).getSeconds();
      let time = [];
      if (startH <= 18) {
        time = [`${startH}:${startM}:${startS} - ${endH}:${endM}:${endS}`];
      } else {
        time = [`00:00:00 - ${endH}:${endM}:${endS}`];
      }
      this.$set(this.pickerEndDateOptions, "selectableRange", time);
      !val
        ? this.handleChangeTime()
        : (this.queryData.startTime = +new Date(val));
    },
    handleChangeTime() {
      this.settleStrartDate = null;
      this.settleEndDate = null;
      this.freeDate = null;
      this.queryData.startTime = "";
      this.queryData.endTime = "";
    },
    // 清空
    handleClear() {
      this.chooseDate = [];
      if (this.queryData.dateType == 2) {
        this.queryData = {
          period: 24,
          current: 1,
          //labelIds: [],
          levelId: "",
          size: 50,
          dateType: 2,
          rankFieldType: 1,
          startTime: "",
          endTime: "",
          ascSort: false,
          minBets: null,
          minStake: null,
          minProfit: null,
          minLowBets: null,
          minProfitPercentage: null,
          minRejectPercentage: null,
          channelId: null
        };
      } else {
        this.queryData = {
          period: 100,
          current: 1,
          //labelIds: [],
          levelId: "",
          size: 50,
          dateType: 1,
          rankFieldType: 1,
          startTime: "",
          endTime: "",
          ascSort: false,
          minBets: null,
          minStake: null,
          minProfit: null,
          minLowBets: null,
          minProfitPercentage: null,
          minRejectPercentage: null,
          channelId: null
        };
      }
    },

    handleSaveQuery() {
      localStorage.setItem("rankSearchQuery", JSON.stringify(this.queryData));
    },
    // utc时间
    formatUtc(time, type) {
      if (type == 1) {
        return this.$moment(+time).format("YYYY-MM-DD");
      } else {
        return this.$moment(+time - 24 * 60 * 60 * 1000 - 1).format(
          "YYYY-MM-DD"
        );
      }
    },
    formatUtcYM(time, type) {
      if (type == 1) {
        return this.$moment(+time).format("YYYY-MM");
      } else {
        return this.$moment(+time - 24 * 60 * 60 * 1000 - 1).format("YYYY-MM");
      }
    },
    formatUtcMs(time) {
      return time ? this.$moment(+time).format("YYYY-MM-DD HH:mm:ss") : "";
    },
    initChart() {
      this.orderChart = echarts.init(document.getElementById("orderAmount"));
      this.orderChart.clear();
      this.type == 1
        ? this.orderChart.setOption(option)
        : this.orderChart.setOption(mixoption);
    },
    async getChartList() {
      this.initChart();
      const { data, code, message } = await getChartList(this.chartQueryData);
      if (code === 8013) {
        this.$message({ message: message, type: "warning" });
      }
      if (data && data.length > 0) this.orderChart.hideLoading();
      const getXAxis = (data || []).map(d => {
        let date = this.$moment(+d.reportDate).format("MM/DD");
        let time = this.$moment(+d.reportDate).format("HH:mm");
        return `${date}\n${time}`;
      });

      if (this.type == 1) {
        const stakeSeries = (data || []).map(d => ({
          date: this.$moment(+d.reportDate).format("YYYY-MM-DD HH:mm"),
          value: d.totalStake
        }));
        this.orderChart.setOption({
          tooltip: {
            formatter(params) {
              let htmlStr;
              let date = params[0].data.date;
              let value = params[0].data.value;
              return `<div class='echart-tooltip'><p>${date}</p><p>Stake: ${value}</p></div>`;
            }
          },
          xAxis: {
            data: getXAxis
          },
          series: [
            {
              data: stakeSeries
            }
          ]
        });
      } else if (this.type == 2) {
        const PLSeries = (data || []).map(d => ({
          date: this.$moment(+d.reportDate).format("YYYY-MM-DD HH:mm"),
          value: d.totalProfit
        }));
        const PLPrecentSeries = (data || []).map(d => ({
          date: this.$moment(+d.reportDate).format("YYYY-MM-DD HH:mm"),
          value: d.totalPl
        }));
        const PLSeriesData = PLSeries.map(item => Math.abs(item.value));
        const PLPrecentSeriesData = PLPrecentSeries.map(item =>
          Math.abs(item.value)
        );
        this.orderChart.setOption({
          tooltip: {
            formatter(params) {
              let htmlStr;
              let date = params[0].data.date;
              let value = params[0].data.value;
              let PLPrecentvalue = params[1] ? params[1].data.value : 0;
              let PLmarker = params[0].marker;
              let PLPremarker = params[1] ? params[1].marker : "";
              return `<div class='echart-tooltip'><p>${date}</p><p>${PLmarker}P/L: ${value}</p><p>${PLPremarker}P/L%: ${PLPrecentvalue}%</p></div>`;
            }
          },
          xAxis: {
            data: getXAxis
          },
          yAxis: [
            {
              interval: Math.ceil(Math.ceil(Math.max(...PLSeriesData)) / 5),
              max: Math.ceil(Math.ceil(Math.max(...PLSeriesData)) / 5) * 5,
              min: -Math.ceil(Math.ceil(Math.max(...PLSeriesData)) / 5) * 5
            },
            {
              interval: Math.ceil(
                Math.ceil(Math.max(...PLPrecentSeriesData)) / 5
              ),
              max:
                Math.ceil(Math.ceil(Math.max(...PLPrecentSeriesData)) / 5) * 5,
              min:
                -Math.ceil(Math.ceil(Math.max(...PLPrecentSeriesData)) / 5) * 5
            }
          ],
          series: [
            {
              data: PLSeries,
              itemStyle: {
                emphasis: {
                  barBorderRadius:
                    PLSeriesData > 0 ? [7, 7, 0, 0] : [0, 0, 7, 7]
                },
                normal: {
                  color: function(e) {
                    return e.value > 0 ? "#E1554F" : "#A7B9C7";
                  }
                  // barBorderRadius: PLSeriesData > 0 ? [7,7,0,0] : [0,0,7,7]
                }
              }
            },
            {
              data: PLPrecentSeries,
              itemStyle: {
                normal: {
                  color: "#4690FF"
                }
              }
            }
          ]
        });
      }
    },
    handleViewChart(num, data) {
      this.num = num;
      this.title = "";
      this.chartQueryData.userId = data.userId;
      this.chartQueryData.period = this.queryData.period;
      this.$nextTick(() => {
        this.getChartList();
      });
      this.$refs["dialogDom"].isShowDia(this.title, true, "1023px");
    },
    handleChange(type) {
      this.type = type;
      this.getChartList();
    },
    //向下取整保留两位小数
    formatNumber(num) {
      return Math.floor(num * 100) / 100;
    }
  },
  components: {
    dia,
    Empty
  },
  computed: {
    sortedArr() {
      const arrCopy = [...this.riskLevelList];
      arrCopy.sort((a, b) => {
        const nameA = a.name.toUpperCase();
        const nameB = b.name.toUpperCase();
        // 先将 "Default" 排到最前面
        if (nameA === "DEFAULT") return -1;
        if (nameB === "DEFAULT") return 1;
        // 如果都是 "数字%group" 的形式，则按数字大小升序排列
        const regex = /(\d+)\s*%\s*group/i;
        const matchA = nameA.match(regex);
        const matchB = nameB.match(regex);
        if (matchA && matchB) {
          const numA = parseInt(matchA[1]);
          const numB = parseInt(matchB[1]);
          return numA - numB;
        }
        // 如果都不是 "数字%group" 的形式，则按字典序升序排列
        if (!matchA && !matchB) {
          if (nameA < nameB) return -1;
          if (nameA > nameB) return 1;
          return 0;
        }
        // 如果只有一个是 "数字%group" 的形式，则将不是 "数字%group" 的排在前面
        return matchA ? -1 : 1;
      });
      return arrCopy;
    }
    //利用button display属性添加禁止
    // pickerVisible() {
    //   if (this.$refs.saveDateInput.pickerVisible) {
    //     return true;
    //   } else {
    //     return false;
    //   }
    // }
  },
  mounted() {
    let d = [];
    d = [
      new Date(new Date().toLocaleDateString()).getTime(),
      new Date(new Date().toLocaleDateString()).getTime() +
        24 * 60 * 60 * 1000 -
        1
    ];
    this.chooseDate = [d[0], d[1]];
    this.firstActive = true;
    this.offset = new Date().getTimezoneOffset();
    const rankSearch = JSON.parse(localStorage.getItem("rankSearchQuery"));
    this.queryData.minLowBets = rankSearch ? rankSearch.minLowBets : null;
    this.queryData.minBets = rankSearch ? rankSearch.minBets : null;
    this.queryData.minProfit = rankSearch ? rankSearch.minProfit : null;
    this.queryData.minProfitPercentage = rankSearch
      ? rankSearch.minProfitPercentage
      : null;
    this.queryData.minRejectPercentage = rankSearch
      ? rankSearch.minRejectPercentage
      : null;
    this.queryData.minStake = rankSearch ? rankSearch.minStake : null;

    // 当前时间最近6小时 = （当前时间-当天0点）/6  以6小时为区间一共4个
    let timeDifferent = Math.ceil(
      (new Date().getTime() -
        new Date(new Date().toLocaleDateString()).getTime()) /
        3600 /
        1000 /
        6
    );
    // this.settleEndDate = this.queryData.endTime =
    //   new Date(new Date().toLocaleDateString()).getTime() +
    //   timeDifferent * 6 * 3600 * 1000 -
    //   1;
    // this.settleStartDate = this.queryData.startTime =
    //   this.queryData.endTime - 6 * 3600 * 1000 + 1;

    //this.handleQuery(this.isFirstTime);
    this.fetchMerchantList();
    this.getRiskLevel();
    this.getLableList();
    this.getLevelList();
    this.getList();
    this.$nextTick(() => {
      let self = this;
      self.tableHeight =
        window.innerHeight - self.$refs.table.$el.offsetTop - 94;
      window.onresize = function() {
        self.tableHeight =
          window.innerHeight - self.$refs.table.$el.offsetTop - 94;
      };
    });
  }
};
</script>

<style lang="scss" scoped>
.ranking-date,
.export-wrapper {
  font-size: 12px;
  margin: 10px 0;
  .header-tab {
    display: flex;
    align-items: center;
    height: 32px;
    width: 200px;
    margin-right: 10px;
    span {
      width: 100px;
      text-align: center;
      cursor: pointer;
      line-height: 30px;
      border: 1px solid #dcdfe6;
      &.active {
        color: #fff;
        background: #00a791;
        border: 1px solid #00a791;
      }
      &:hover {
        opacity: 0.7;
      }
    }
    .fisrt-box {
      border-radius: 4px 0 0 4px;
      border-right: 0;
    }
    .two-box {
      border-radius: 0 4px 4px 0;
      border-left: 0;
    }
  }
}
.middle-btn {
  margin: 0 0 10px 0;
}
.label-btn {
  border: 1px solid #dcdfe6;
  width: 102px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.order-amount-wrapper {
  text-align: center;
  background-color: #fff;
  border-radius: 16px;
  .time-range-box {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    .time-range {
      left: 0;
      right: 0;
      margin: auto;
      border-radius: 100px;
      display: flex;
      border: 1px solid #ebedf3;
      p {
        color: #414b5f !important;
        font-weight: normal;
        font-size: 13px;
        padding: 7px 35px;
        margin-left: 0;
        border-right: 1px solid #ebedf3;

        box-sizing: border-box;
        cursor: pointer;
        &:last-child {
          border-right: 0;
          border-radius: 0 100px 100px 0;
        }
        &:first-child {
          border-radius: 100px 0px 0px 100px;
        }
        &.active {
          color: #fff !important;
          background: #00a791;
          border: 1px solid #00a791;
        }
      }
    }
  }
}
#orderAmount {
  height: 378px;
}
.icona-Property1baocun {
  font-size: 12px;
}
.odds-tag {
  display: inline-block;
  line-height: 20px;
  text-align: center;
  margin-right: 6px;
  background: #00a791;
  border-radius: 2px;
  width: 20px;
  height: 20px;
  color: #fff;
}
.iconqushi {
  font-size: 16px;
  color: #0184b8;
}
.el-range-editor--small.el-input__inner {
  width: 260px;
}
/deep/.el-input-group__append {
  padding: 0 5px !important;
}
/deep/.el-date-editor--week {
  width: 140px !important;
}
.label-box {
  /deep/.el-input {
    width: 240px !important;
  }
}
</style>
